export default function formatDate(date: string) {
	const convertedDate = new Date(date?.toString());
	const currentMonth = convertedDate.getMonth() + 1;
	const monthString = currentMonth >= 10 ? currentMonth : `0${currentMonth}`;
	const currentDate = convertedDate.getDate();
	return `${currentDate}-${monthString}-${convertedDate.getFullYear()}`;
}
